const popularAndroidLinks = [
  {
    data: {
      id: '1',
      anchortag: 'Bengali',
      link:
        'https://play.google.com/store/apps/details?id=com.bengalishaadi.android',
      type: 'By Mother Tongue',
      subtype: 'link',
      orderby: '1',
    },
  },
  {
    data: {
      id: '5',
      anchortag: 'Marathi',
      link:
        'https://play.google.com/store/apps/details?id=com.marathishaadi.android',
      type: 'By Mother Tongue',
      subtype: 'link',
      orderby: '1',
    },
  },
  {
    data: {
      id: '7',
      anchortag: 'Punjabi',
      link:
        'https://play.google.com/store/apps/details?id=com.punjabishaadi.android',
      type: 'By Mother Tongue',
      subtype: 'link',
      orderby: '1',
    },
  },
  {
    data: {
      id: '6',
      anchortag: 'Odia',
      link:
        'https://play.google.com/store/apps/details?id=com.odiashaadi.android',
      type: 'By Mother Tongue',
      subtype: 'link',
      orderby: '1',
    },
  },
  {
    data: {
      id: '2',
      anchortag: 'Gujarati',
      link:
        'https://play.google.com/store/apps/details?id=com.gujaratishaadi.android',
      type: 'By Mother Tongue',
      subtype: 'link',
      orderby: '1',
    },
  },
  {
    data: {
      id: '8',
      anchortag: 'Tamil',
      link:
        'https://play.google.com/store/apps/details?id=com.tamilshaadi.android',
      type: 'By Mother Tongue',
      subtype: 'link',
      orderby: '1',
    },
  },
  {
    data: {
      id: '9',
      anchortag: 'Telugu',
      link:
        'https://play.google.com/store/apps/details?id=com.telugushaadi.android',
      type: 'By Mother Tongue',
      subtype: 'link',
      orderby: '1',
    },
  },
  {
    data: {
      id: '4',
      anchortag: 'Malayalam',
      link:
        'https://play.google.com/store/apps/details?id=com.malayaleeshaadi.android',
      type: 'By Mother Tongue',
      subtype: 'link',
      orderby: '1',
    },
  },
  {
    data: {
      id: '3',
      anchortag: 'Kannada',
      link:
        'https://play.google.com/store/apps/details?id=com.kannadashaadi.android',
      type: 'By Mother Tongue',
      subtype: 'link',
      orderby: '1',
    },
  },
  {
    data: {
      id: '10',
      anchortag: 'Buddhist',
      link:
        'https://play.google.com/store/apps/details?id=com.buddhistshaadi.android',
      type: 'By Religion',
      subtype: 'link',
      orderby: '2',
    },
  },
  {
    data: {
      id: '11',
      anchortag: 'Christian',
      link:
        'https://play.google.com/store/apps/details?id=com.christianshaadi.android',
      type: 'By Religion',
      subtype: 'link',
      orderby: '2',
    },
  },
  {
    data: {
      id: '15',
      anchortag: 'Sikh',
      link:
        'https://play.google.com/store/apps/details?id=com.sikhshaadi.android',
      type: 'By Religion',
      subtype: 'link',
      orderby: '2',
    },
  },
  {
    data: {
      id: '12',
      anchortag: 'Jain',
      link:
        'https://play.google.com/store/apps/details?id=com.jainshaadi.android',
      type: 'By Religion',
      subtype: 'link',
      orderby: '2',
    },
  },
  {
    data: {
      id: '14',
      anchortag: 'Parsi',
      link:
        'https://play.google.com/store/apps/details?id=com.parsishaadi.android',
      type: 'By Religion',
      subtype: 'link',
      orderby: '2',
    },
  },
  {
    data: {
      id: '13',
      anchortag: 'Muslim',
      link:
        'https://play.google.com/store/apps/details?id=com.muslimshaadi.android',
      type: 'By Religion',
      subtype: 'link',
      orderby: '2',
    },
  },
  {
    data: {
      id: '20',
      anchortag: 'Maratha',
      link:
        'https://play.google.com/store/apps/details?id=com.marathashaadi.android',
      type: 'By Community',
      subtype: 'link',
      orderby: '3',
    },
  },
  {
    data: {
      id: '24',
      anchortag: 'Reddy',
      link:
        'https://play.google.com/store/apps/details?id=com.reddyshaadi.android',
      type: 'By Community',
      subtype: 'link',
      orderby: '3',
    },
  },
  {
    data: {
      id: '16',
      anchortag: 'Brahmin',
      link:
        'https://play.google.com/store/apps/details?id=com.brahminshaadi.android',
      type: 'By Community',
      subtype: 'link',
      orderby: '3',
    },
  },
  {
    data: {
      id: '18',
      anchortag: 'Kamma',
      link:
        'https://play.google.com/store/apps/details?id=com.kammashaadi.android',
      type: 'By Community',
      subtype: 'link',
      orderby: '3',
    },
  },
  {
    data: {
      id: '22',
      anchortag: 'Nair',
      link:
        'https://play.google.com/store/apps/details?id=com.nairshaadi.android',
      type: 'By Community',
      subtype: 'link',
      orderby: '3',
    },
  },
  {
    data: {
      id: '21',
      anchortag: 'Nadar',
      link:
        'https://play.google.com/store/apps/details?id=com.nadarshaadi.android',
      type: 'By Community',
      subtype: 'link',
      orderby: '3',
    },
  },
  {
    data: {
      id: '19',
      anchortag: 'Kapu',
      link:
        'https://play.google.com/store/apps/details?id=com.kapushaadi.android',
      type: 'By Community',
      subtype: 'link',
      orderby: '3',
    },
  },
  {
    data: {
      id: '17',
      anchortag: 'Ezhava',
      link:
        'https://play.google.com/store/apps/details?id=com.ezhavashaadi.android',
      type: 'By Community',
      subtype: 'link',
      orderby: '3',
    },
  },
  {
    data: {
      id: '23',
      anchortag: 'Rajput',
      link:
        'https://play.google.com/store/apps/details?id=com.rajputshaadi.android',
      type: 'By Community',
      subtype: 'link',
      orderby: '3',
    },
  },
  {
    data: {
      id: '30',
      anchortag: 'All Communities',
      link: 'https://play.google.com/store/apps/details?id=com.shaadi.android',
      type: 'By Community',
      subtype: 'morelink',
      orderby: '3',
    },
  },
]

export { popularAndroidLinks }
